import { isSignInRequired } from "owa-app-auth-ui-store";
import { isMsalFlowEnabled } from "owa-msaljs/lib/isMsalFlowEnabled";

export function showMsalAuthInfoBar(): boolean {
    return isMsalFlowEnabled() && isSignInRequired();
}
